import type { PropsWithChildren } from 'react'

import styles from './AudioDetailsGroup.module.css'

/**
 * The tighter sub-rhythm inside the details panel: audio-web keeps licence + stats + the Audacity
 * banner 16px apart so the three read as one block within the panel's 48px spacing.
 */
export const AudioDetailsGroup = ({ children }: PropsWithChildren) => (
    <div className={styles.group}>{children}</div>
)
